const archLevel: any = 'sponsor';
const REACT_APP_API_ISF = `https://isf-api-`;
const REACT_APP_API_TSDA = `https://tsda-api-`;
export { REACT_APP_API_ISF, REACT_APP_API_TSDA, archLevel };
